import {
    getPaycodeAssign,
    getShifts,
    getAbsences,
    getPaycodeDuration,
    getPaycodeAssignById,
    addShift,
    updateShift,
    getPaycodes,
    assignPaycode,
    updatePaycode,
    editPaycode,
    deletePaycode,
    deleteShift,
} from './schedule';

const serviceSchedule = {
    getPaycodeAssign,
    getPaycodeAssignById,
    getPaycodeDuration,
    getShifts,
    getAbsences,
    addShift,
    updateShift,
    getPaycodes,
    assignPaycode,
    editPaycode,
    updatePaycode,
    deletePaycode,
    deleteShift,
};

export { serviceSchedule };
